import { Injectable } from '@angular/core';
import { SearchBoxComponentService } from '@spartacus/storefront';
import { filter, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomSearchBoxComponentService extends SearchBoxComponentService {

/**
 * Navigates to the search result page with a given query
 * after waiting for all search operations to complete
 */
  launchSearchPage(query: string): void {
    // Wait for search to complete and then navigate
    this.searchCompleted
      .pipe(
        filter(completed => completed),
        take(1),
        tap(() => {
          this.searchCompleted.next(false);
          this.routingService.go({
            cxRoute: 'search',
            params: { query },
          });
        })
      )
      .subscribe();
  }
}
